module.exports = __webpack_public_path__ + "img/34 alcanzaras.d4019ad8.jpg";